import { render, staticRenderFns } from "./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=template&id=18a198c2&"
import script from "./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a198c2')) {
      api.createRecord('18a198c2', component.options)
    } else {
      api.reload('18a198c2', component.options)
    }
    module.hot.accept("./ReferralProgramCreateAndUpdateFormItems.vue?vue&type=template&id=18a198c2&", function () {
      api.rerender('18a198c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralProgramCreateAndUpdateFormItems.vue"
export default component.exports